/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Model(props) {
  const { nodes, materials } = useGLTF('assets/glb-file/17.glb')
  return (
    <group {...props} dispose={null}>
      <group scale={0.01}>
        <mesh geometry={nodes.steam_train1.geometry} material={nodes.steam_train1.material} />
      </group>
    </group>
  )
}

//useGLTF.preload('assets/glb-file/17.glb')
